import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BUILD_INFO } from '../../../core/constants/build-info';

@Component({
  selector: 'app-build-version',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<span title="Versão do painel carregada neste navegador">Versão {{ version }}</span>',
  styles: `
    :host {
      display: block;
      color: #6b7280;
      font-size: 12px;
      line-height: 20px;
      font-variant-numeric: tabular-nums;
      overflow-wrap: anywhere;
    }
  `,
})
export class BuildVersionComponent {
  readonly version = BUILD_INFO.version;
}
